import type { ReactNode } from 'react';
import U2000RequireRole from '../u2000Core/components/controls/U2000RequireRole';
import U3151, { U3151ROLES } from './U3151';
import U3151CustomerTypeList from './components/U3151CustomerTypeList';
import U3151CustomerTypeForm from './components/U3151CustomerTypeForm';

interface RouteObject {
  path?: string;
  index?: boolean;
  element?: ReactNode;
  children?: RouteObject[];
}

const U3151Routes: RouteObject[] = [
  {
    path: 'U3151',
    element: <U2000RequireRole allowedRoles={[U3151ROLES.READ]} />,
    children: [
      {
        path: '',
        element: <U3151 />,
        children: [
          { index: true, element: <U3151CustomerTypeList /> },
          { path: ':id', element: <U3151CustomerTypeForm /> },
        ],
      },
    ],
  },
];

export default U3151Routes;
